/**
 * Created by slava on 02.02.17.
 */

const KingsCupCellView = BaseCellView.extend({
    ctor: function (cell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        const image = this.image = new cc.Sprite(Mission.getCollectIcon(Mission.TYPE_KINGSCUP));
        image.setPosition(this.width / 2, this.height / 2);
        image.setScale(cleverapps.styles.KingsCupCellView.scale);
        this.addChild(image);

        this.initialize(cell);

        const previousOnFinishAppear = cell.onFinishAppear;
        cell.onFinishAppear = function () {
            previousOnFinishAppear.call(this);
            cleverapps.effects.fire("match3.kingscup.appear");
        };
    },

    startExploding: function () {
        const game = Game.currentGame;

        if (!game || game.outcome !== GameBase.OUTCOME_UNKNOWN) {
            this.delete();
            return;
        }

        MissionCollectDelta.showOver(Mission.TYPE_KINGSCUP, 1, this);

        this.stopAllActions();
        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0.15, 1.3).easing(cc.easeOut(2)),
            new cc.CallFunc(this.showSparks.bind(this)),
            new cc.Spawn(
                new cc.ScaleTo(0.3, 0).easing(cc.easeBackIn()),
                new cc.FadeOut(0.3)
            ),
            new cc.CallFunc(() => {
                cleverapps.eventBus.trigger("collectKingsCupMark", 1);
                this.delete();
            })
        ));
    },

    showSparks: function () {
        const sparks = new cleverapps.Spine(bundles.animations_library.jsons.sparks_json);
        sparks.setSkin("yellow");
        sparks.setAnimation(0, "single", false);
        sparks.setCompleteListenerRemove();
        sparks.setPosition(this.getPosition());
        this.getParent().addChild(sparks, this.getLocalZOrder() + 1);
    }
});

cleverapps.styles.KingsCupCellView = {
    scale: 1.2
};
